import { createRouter, createWebHistory, NavigationGuard, RouteRecordRaw } from 'vue-router'
import routes from './routes'

import {
  beforeResolve,
  afterEach,
  checkAuthentication,
  checkTokenRequired,
  checkFeatureFlags,
  handleRouteSpecificRedirects,
  setDocumentTitle,
} from './hooks'
import config from '@/config'

const routerOptions = {
  history: createWebHistory(config.RELATIVE_URL_PATH ? `/${config.RELATIVE_URL_PATH}` : undefined),
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: routes as RouteRecordRaw[],
}

const router = createRouter(routerOptions)

router.beforeEach(checkAuthentication as NavigationGuard)
router.beforeEach(checkFeatureFlags as NavigationGuard)
router.beforeEach(checkTokenRequired as NavigationGuard)
router.beforeEach(handleRouteSpecificRedirects as NavigationGuard)
router.beforeResolve(beforeResolve as NavigationGuard)
router.beforeResolve(setDocumentTitle as NavigationGuard)
router.afterEach(afterEach)

export default router
